import { StyledSectionTitle, StyledOverview } from './details-page-styles'

interface Props {
  overview?: string
}

const DetailsOverview = ({ overview }: Props) => {
  if (!overview) return null

  return (
    <>
      <StyledSectionTitle>Overview</StyledSectionTitle>
      <StyledOverview>{overview}</StyledOverview>
    </>
  )
}

export default DetailsOverview
